<mat-form-field class="select-search" cropFieldLabel>
  <mat-label>
    <span class="tw-flex tw-items-center">
      <span cropText>
        {{ placeholderName }}
      </span>

      <ng-container *ngIf="tooltipText">
        <ui-svg-icon
          [name]="iconsNames.QuestionFrame"
          [matTooltip]="tooltipText | translate"
          class="help-icon__with-height tw-align-middle"
        ></ui-svg-icon>
      </ng-container>
    </span>
  </mat-label>
  <mat-select
    [attr.test-id]="testId"
    [formControl]="selectControl"
    [disabledControl]="isDisabled"
    #singleSelect
    [multiple]="isMultiple"
    (openedChange)="onOpenedChange($event)"
  >
    <mat-option class="search-option">
      <div class="search-container">
        <input
          #searchInput
          matInput
          [formControl]="searchControl"
          [placeholder]="'common.filter.search.label' | translate"
          (click)="$event.stopPropagation()"
        />

        <button *ngIf="searchControl.value" mat-icon-button class="clear-btn" (click)="onSearchClear($event)">
          <ui-svg-icon [name]="iconsNames.Close" class="tw-text-red-600"></ui-svg-icon>
        </button>
      </div>
    </mat-option>
    <mat-option
      *ngFor="let optionItem of filteredOptionItems$ | async; let first = first"
      [ngClass]="{ 'separate-default-option': first && firstIsDefault && !searchControl.value }"
      [value]="optionItem.id"
      [attr.test-id]="optionItem.id"
    >
      {{ optionItem.name }}
    </mat-option>
  </mat-select>

  <ng-container *ngIf="showClearButton && selectControl.value" matSuffix>
    <ui-svg-icon [name]="iconsNames.Close" (click)="onClearButtonClick($event)"></ui-svg-icon>
  </ng-container>

  <mat-hint *ngIf="hintText" class="info-text">{{ hintText | translate }}</mat-hint>
  <mat-error>
    <ng-content></ng-content>
  </mat-error>
</mat-form-field>
